import { useReducer } from 'react';

const getExpBackoff = (multiplier: number, base: number, exponent: number): number => {
  // x * (y ^ z)
  return multiplier * base ** exponent;
};

interface ExpBackoffState {
  base: number;
  count: number;
}

type ExpBackoffAction =
  | { type: 'RESET'; payload: { base: number } }
  | { type: 'INCREMENT' };

// Exponential Backoff
export const useExpBackoff = (initVal: number, maxVal: number) => {
  const initialState: ExpBackoffState = { base: initVal, count: 0 };
  const reducer = (prevState: ExpBackoffState, action: ExpBackoffAction): ExpBackoffState => {
    switch (action.type) {
      case 'RESET':
        return {
          count: 0,
          base: action.payload.base,
        };
      case 'INCREMENT':
        return {
          ...prevState,
          count: prevState.count + 1,
        };
      default:
        return prevState;
    }
  };
  const [state, dispatch] = useReducer(reducer, initialState);

  const increment = () => {
    dispatch({ type: 'INCREMENT' });
  };
  const reset = (newBase = 0) => {
    let { base } = state;
    if (newBase > 0) base = newBase;

    dispatch({
      type: 'RESET',
      payload: { base },
    });
  };

  const val = Math.min(getExpBackoff(state.base, 2, state.count), maxVal);

  return { val, increase: increment, reset };
};